module.exports = __webpack_public_path__ + "img/20191204172546360截图20191204164243841.304c934c.jpg";